import React from 'react';
import { MyChatBubble } from '../players/MyChatBubble';
import { gql } from '@urql/core';
import { PlayerChatBubblesFragment, Espin_Message_Type_Enum } from '../../../../generated/spin-graphql';
import { PlayerIncomingChatBubble } from '../players/PlayerIncomingChatBubble';

type Props = {
    conversation?: PlayerChatBubblesFragment[];
};

gql`
    fragment PlayerChatBubbles on espin_message {
        ...PlayerIncomingChatBubble
        ...MyChatBubble
        message_type
        college {
            logo {
                ...SpinContentImageDisplay
            }
        }
    }
`;

export const HighSchoolChatBubbles: React.FC<Props> = ({ conversation }) => {
    const profileImage = conversation[0].college?.logo;
    return (
        <div className="chat-bubbles-container">
            {conversation.map((message, index) => {
                if (message.message_type === Espin_Message_Type_Enum.HighSchoolMessagesCollege) {
                    return <MyChatBubble key={`chat-bubble-${index}`} message={message} />;
                }

                return (
                    <PlayerIncomingChatBubble key={`chat-bubble-${index}`} picture={profileImage} message={message} />
                );
            })}
        </div>
    );
};
